import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Section from 'components/organisms/Section';
import ReportListHome from 'components/templates/Home/ReportListHome';
import SsoModal from 'components/templates/SsoModal';
import useDownloadReport from 'hooks/useDownloadReport';
import useLoginSSO from 'hooks/useLoginSSO';
import { useAppSelector } from 'store/hooks';
import { getLinkLoginSSO } from 'utils/ssoHelper';

export interface AnalysisReport {
  title: string;
  link: {
    text: string;
    url: string;
    target: string;
  };
}

interface ReportListBlocks {
  blocks: AnalysisReport;
}

const ReportList: React.FC<ReportListBlocks> = ({
  blocks,
}) => {
  const { t } = useTranslation();
  const clientId = useAppSelector((state) => state.system.dataSystem?.customerSSOClientId);
  const language = useAppSelector((state) => state.system.language);

  const { hrefLoginSSO, handleCloseOpenSSO } = useLoginSSO();

  const {
    reportListData,
    loadingReportList,
    openLoginSSO,
    setOpenLoginSSO,
  } = useDownloadReport(true);

  const onHandleCloseOpenSSO = useCallback(() => {
    handleCloseOpenSSO();
    setOpenLoginSSO(false);
  }, [handleCloseOpenSSO, setOpenLoginSSO]);

  return (
    (
      <Section className="p-home_reportList">
        <ReportListHome
          title={blocks.title}
          viewMoreText={blocks.link.text}
          href={blocks.link.url}
          target={blocks.link.target}
          loginSSOLink={getLinkLoginSSO(language, clientId)}
          reportList={reportListData}
          loading={loadingReportList}
        />
        <SsoModal
          isOpen={openLoginSSO}
          content={t('modal.please_login_to_download_this_report')}
          title={t('modal.please_login')}
          handleClose={onHandleCloseOpenSSO}
          hrefLoginSSO={hrefLoginSSO}
          cancelText={t('modal.cancel')}
          confirmText={t('modal.login')}
        />
      </Section>
    )
  );
};

export default ReportList;
